/* eslint-disable no-undef */
/**
 * Utilidades de fecha para el módulo de citas médicas.
 */

/**
 * Convierte una fecha en formato "DD/MM/YYYY HH:mm" a "YYYY-MM-DD".
 * @param {string} dateSet - Fecha en formato crudo proveniente del API.
 * @returns {string|null}
 */
export const formatDate = (dateSet) => {
  if (dateSet === null || dateSet === undefined) return null;
  const date = dateSet.split(' ')[0];
  const arrDate = date.split('/');
  return `${arrDate[2]}-${arrDate[1]}-${arrDate[0]}`;
};

/**
 * Calcula la cantidad de días absolutos entre dos fechas.
 * @param {Date|string} date1 - Fecha de inicio.
 * @param {string} date2 - Fecha de fin en formato YYYYMMDD.
 * @returns {number}
 */
export const getDaysBetweenDates = (date1, date2) => {
  const startDate = moment(date1);
  const endDate = moment(date2, 'YYYYMMDD');
  return Math.abs(endDate.diff(startDate, 'days'));
};
